import { render, staticRenderFns } from "./VideoSplash.vue?vue&type=template&id=0bdc141c&"
import script from "./VideoSplash.vue?vue&type=script&lang=js&"
export * from "./VideoSplash.vue?vue&type=script&lang=js&"
import style0 from "./VideoSplash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports